export enum StatisticsTimeInterval {
    Today = 'Today',
    Yesterday = 'Yesterday',
    LastWeek = 'Last week',
    LastMonth = 'Last month',
    Last7Days = 'Last 7 days',
    Last30Days = 'Last 30 days'
}
